module.exports = __webpack_public_path__ + "img/31.fc1ac6f9.webp";